import { Component, OnInit } from '@angular/core';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { AdminLayoutModule } from './layout.module';
import { CommonModule } from '@angular/common';
import { UsersService } from '../../services/users/users.service';
import { AdminData } from '../../resolvers/admin-data.resolver';

@Component({
  selector: 'app-layout',
  imports: [CommonModule, RouterModule, AdminLayoutModule],
  templateUrl: './layout.html',
  styleUrls: ['./layout.scss'],
})
export class AdminLayoutComponent implements OnInit {
  constructor(
    public userService: UsersService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    // Obtener datos pre-cargados por el resolver
    const adminData = this.route.snapshot.data['adminData'] as AdminData;
    if (adminData?.permissions) {
      this.userService.permissions = adminData.permissions;
    }
  }
}
